// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/logo.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relieving_main_container {
  padding: 20px;
  background: #f9f9f9;
}

.relieving_button_group {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.relieving_download_button,
.relieving_close_button {
  padding: 8px 16px;
  background-color: #d34508;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.relieving_letter_container {
  background: white;
  /* padding: 10px; */
  
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.relieving_header_section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* margin-bottom: 20px; */
}
.relieving_company_logo_container {
    width:50%;
    /* background-color: rgb(0, 0, 0); */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.relieving_company_logo {
  height: 195px;
  width:auto;
  object-fit: contain;
  /* margin-bottom: 20px; */
}

.relieving_company_details {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    /* padding-left: 50px; */
}

.relieving_detail_row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 4px;
  gap: 8px;
}

.relieving_detail_text {
  margin-right: 12px;
  font-size: 14px;
  /* text-align: right; */
}

.relieving_icon_box {
 
  padding: 10px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

.relieving_line_thin {
  border: 1px solid rgb(167, 5, 86);
  margin-bottom: 2px;
}

.relieving_line_thick {
    border: 3px solid rgb(0 0 0);
}

.relieving_letter_heading {
  text-align: center;
  margin: 20px 0;
}

.relieving_employee_info {
  padding: 10px 0 10px 20px;
}

.relieving_paragraph {
  margin-left: 20px;
  margin-top: 15px;
}

.relieving_employment_details {
  list-style: none;
  margin-top: 20px;
  margin-left: 20px;
  padding: 0;
}

.relieving_employment_details li {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  margin-bottom: 10px;
}

.relieving_signature {
  margin-left: 20px;
  margin-top: 50px;
}

/* Responsive Styles */
@media (min-width: 768px) {
  .relieving_header_section {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .relieving_company_logo {
    margin-bottom: 0;
  }

 

  .relieving_letter_container {
    /* padding: 10px; */
  }

  .relieving_paragraph,
  .relieving_signature,
  .relieving_employee_info,
  .relieving_employment_details {
    /* margin-left: 150px; */
  }
}

@media (max-width: 767px) {
  .relieving_download_button,
  .relieving_close_button {
    font-size: 14px;
    padding: 6px 12px;
  }

  .relieving_paragraph,
  .relieving_signature,
  .relieving_employee_info,
  .relieving_employment_details {
    margin-left: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/latters/relievinglatter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;;EAEnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;IACI,SAAS;IACT,oCAAoC;IACpC,yDAA8C;IAC9C,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;;;;EAIA;IACE,mBAAmB;EACrB;;EAEA;;;;IAIE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;;;IAIE,iBAAiB;EACnB;AACF","sourcesContent":[".relieving_main_container {\n  padding: 20px;\n  background: #f9f9f9;\n}\n\n.relieving_button_group {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.relieving_download_button,\n.relieving_close_button {\n  padding: 8px 16px;\n  background-color: #d34508;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.relieving_letter_container {\n  background: white;\n  /* padding: 10px; */\n  \n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.relieving_header_section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  /* margin-bottom: 20px; */\n}\n.relieving_company_logo_container {\n    width:50%;\n    /* background-color: rgb(0, 0, 0); */\n    background-image: url('../../assets/logo.jpg');\n    background-size: cover;\n    background-position: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.relieving_company_logo {\n  height: 195px;\n  width:auto;\n  object-fit: contain;\n  /* margin-bottom: 20px; */\n}\n\n.relieving_company_details {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    /* padding-left: 50px; */\n}\n\n.relieving_detail_row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 4px;\n  gap: 8px;\n}\n\n.relieving_detail_text {\n  margin-right: 12px;\n  font-size: 14px;\n  /* text-align: right; */\n}\n\n.relieving_icon_box {\n \n  padding: 10px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 2px;\n}\n\n.relieving_line_thin {\n  border: 1px solid rgb(167, 5, 86);\n  margin-bottom: 2px;\n}\n\n.relieving_line_thick {\n    border: 3px solid rgb(0 0 0);\n}\n\n.relieving_letter_heading {\n  text-align: center;\n  margin: 20px 0;\n}\n\n.relieving_employee_info {\n  padding: 10px 0 10px 20px;\n}\n\n.relieving_paragraph {\n  margin-left: 20px;\n  margin-top: 15px;\n}\n\n.relieving_employment_details {\n  list-style: none;\n  margin-top: 20px;\n  margin-left: 20px;\n  padding: 0;\n}\n\n.relieving_employment_details li {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 10px;\n}\n\n.relieving_signature {\n  margin-left: 20px;\n  margin-top: 50px;\n}\n\n/* Responsive Styles */\n@media (min-width: 768px) {\n  .relieving_header_section {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .relieving_company_logo {\n    margin-bottom: 0;\n  }\n\n \n\n  .relieving_letter_container {\n    /* padding: 10px; */\n  }\n\n  .relieving_paragraph,\n  .relieving_signature,\n  .relieving_employee_info,\n  .relieving_employment_details {\n    /* margin-left: 150px; */\n  }\n}\n\n@media (max-width: 767px) {\n  .relieving_download_button,\n  .relieving_close_button {\n    font-size: 14px;\n    padding: 6px 12px;\n  }\n\n  .relieving_paragraph,\n  .relieving_signature,\n  .relieving_employee_info,\n  .relieving_employment_details {\n    margin-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
